/** @jsxImportSource theme-ui */
import React from "react";
import { Button as ThemeUiButton, useThemeUI, merge } from "theme-ui";
import camelCase from "lodash/camelCase";

const Button = React.forwardRef(
  (
    {
      href,
      variant = "primary", // primary | secondary
      size = "medium", // small | medium | large
      theme = "dark", // light | dark
      isRound = false, // true | false
      isSelected = false, // true | false
      isDisabled = false, // true | false
      iconBefore,
      iconAfter,
      buttonInnerNoDiv = false,
      sx = {},
      children,
      ...props
    },
    ref
  ) => {
    const { theme: themeUi } = useThemeUI();

    const iconOnly = !children && (iconBefore || iconAfter);

    const variantName = camelCase(
      [
        variant,
        size,
        theme,
        isRound && "round",
        iconOnly && "icon",
        isSelected && "selected",
      ]
        .filter(Boolean)
        .join("-")
    );

    if (!themeUi.buttons.hasOwnProperty(variantName)) {
      console.warn(
        `config/theme.js - theme.buttons is missing variant: "${variantName}"`
      );
    }

    const InnerButton = () => (
      <>
        {iconBefore && <div className="button__icon-before">{iconBefore}</div>}
        {children && buttonInnerNoDiv ? (
          <>{children}</>
        ) : (
          <div className="button__inner">{children}</div>
        )}
        {iconAfter && <div className="button__icon-after">{iconAfter}</div>}
      </>
    );

    if (href) {
      return (
        <a
          href={href}
          ref={ref}
          sx={merge(
            {
              variant: `buttons.${variantName}`,
            },
            sx
          )}
          {...props}
        >
          <InnerButton />
        </a>
      );
    }

    return (
      <ThemeUiButton
        ref={ref}
        type="button"
        variant={variantName}
        sx={sx}
        disabled={isDisabled}
        {...props}
      >
        <InnerButton />
      </ThemeUiButton>
    );
  }
);

export default Button;
